/** @format */

export enum DocumentTemplate {
  V2 = 'v2',
  LITE = 'lite',
}
